export class Conector {
  Nombre: string;
  Descripcion: string;
  Estado: number;
  Version: number;
  Configuracion: string;
  ConfiguracionInOut: string;
  IdTipoConector: number | null;
  TodosUsuarios: boolean;
  Activo: boolean;

  constructor() {
    this.Nombre = "";
    this.Descripcion = "";
    this.Estado = null;
    this.Version = null;
    this.Configuracion = "";
    this.ConfiguracionInOut = "";
    this.IdTipoConector = null;
    this.TodosUsuarios = false;
    this.Activo = false;
  }
}
